import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AirportDetail } from '../model/airportDetail';
import { AIRPORT_DETAIL_MOCK } from '../mocks/airportDetailMock';
import {AirportSearchItem} from '../model/airportSearchItem';
import {environment} from '../../environments/environment';
import {Airport} from '../model/airport';
import { AirportService as AirportServiceModel } from '../model/airportService';

@Injectable({
  providedIn: 'root'
})
export class AirportService {
  constructor(private http: HttpClient) {}

  private readonly FLAGS_BASE_URL = 'https://b46325dbaad6-meetplusgreet.s3.ru1.storage.beget.cloud/flags/4x3';

  getAirportDetail(id: string): Observable<AirportDetail> {
    return of(AIRPORT_DETAIL_MOCK);

    // return this.http.get<AirportDetail>(`/api/airports/${id}`);
  }

  searchAirports(search: string): Observable<Airport[]> {
    return this.http.get<Airport[]>(
      `${environment.apiUrl}/public/airport/search/${encodeURIComponent(search)}`
    );
  }

  getCountryCode(airport: Airport): string {
    return (
      airport.countryObject?.code ||
      airport.country_code ||
      ''
    ).toLowerCase();
  }

  getFlagUrlByCode(code: string): string {
    return `${this.FLAGS_BASE_URL}/${code.toLowerCase()}.svg`;
  }

  getAirportFlagUrl(airport: Airport): string {
    return this.getFlagUrlByCode(this.getCountryCode(airport));
  }

  getAirportServices(airportId: number): Observable<AirportServiceModel> {
    return this.http.get<AirportServiceModel>(
      `${environment.apiUrl}/public/airport-services/${airportId}`
    );
  }
}
